import bird from "../assets/pet/bird.svg";
import cat from "../assets/pet/cat.svg";
import chicken from "../assets/pet/chicken.svg";
import dog from "../assets/pet/dog.svg";
import ferret from "../assets/pet/ferret.svg";
import fish from "../assets/pet/fish.svg";
import frog from "../assets/pet/frog.svg";
import guineaPig from "../assets/pet/guinea pig.svg";
import hamster from "../assets/pet/hamster.svg";
import rabbit from "../assets/pet/rabbit.svg";
import reptile from "../assets/pet/reptile.svg";
import turtle from "../assets/pet/turtle.svg";

const PET_IMAGE_SOURCES: Record<string, string> = {
  "bird.svg": bird,
  "cat.svg": cat,
  "chicken.svg": chicken,
  "dog.svg": dog,
  "ferret.svg": ferret,
  "fish.svg": fish,
  "frog.svg": frog,
  "guinea pig.svg": guineaPig,
  "hamster.svg": hamster,
  "rabbit.svg": rabbit,
  "reptile.svg": reptile,
  "turtle.svg": turtle,
};

const normalizeTokens = (value: string) => {
  const cleaned = value.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  if (!cleaned) return new Set<string>();
  const tokens = cleaned.split(/\s+/).filter(Boolean);
  const normalized = new Set<string>();
  tokens.forEach((token) => {
    normalized.add(token);
    if (token.endsWith("s") && token.length > 1) {
      normalized.add(token.slice(0, -1));
    }
  });
  return normalized;
};

const hasAny = (tokens: Set<string>, options: string[]) =>
  options.some((option) => tokens.has(option));

const getPetImageFile = (value: string) => {
  const tokens = normalizeTokens(value);
  if (!tokens.size) return null;
  if (hasAny(tokens, ["dog", "puppy"])) return "dog.svg";
  if (hasAny(tokens, ["cat", "kitten"])) return "cat.svg";
  if (hasAny(tokens, ["fish", "fist", "aquarium", "aquatic"])) return "fish.svg";
  if (hasAny(tokens, ["bird"])) return "bird.svg";
  if (hasAny(tokens, ["rabbit", "bunny", "hare"])) return "rabbit.svg";
  if (hasAny(tokens, ["guinea", "pig"])) return "guinea pig.svg";
  if (hasAny(tokens, ["hamster", "gerbil"])) return "hamster.svg";
  if (hasAny(tokens, ["ferret"])) return "ferret.svg";
  if (hasAny(tokens, ["reptile", "lizard", "snake"])) return "reptile.svg";
  if (hasAny(tokens, ["turtle", "tortoise"])) return "turtle.svg";
  if (hasAny(tokens, ["frog", "amphibian"])) return "frog.svg";
  if (hasAny(tokens, ["chicken", "hen", "rooster", "chick"])) return "chicken.svg";
  return null;
};

export const getPetImageSrc = (value?: string | null) => {
  if (!value) return null;
  const file = getPetImageFile(value);
  if (!file) return null;
  return PET_IMAGE_SOURCES[file] ?? null;
};
